import publicApiClient from "./publicApiClient";

export interface PublicBranding {
  companyName: string;
  businessName: string;
  subdomain: string;
  logoUrl: string;
  faviconUrl: string;
  primaryColor: string;
  accentColor: string;
  tagline: string;
  welcomeMessage: string;
  chatbotName: string;
  chatbotWelcomeMessage: string;
  aiChatbotEnabled: boolean;
}

const cache = new Map<string, PublicBranding>();

export async function fetchPublicBranding(subdomain: string): Promise<PublicBranding | null> {
  const k = subdomain.trim().toLowerCase();
  if (!k) {
    return null;
  }
  if (cache.has(k)) {
    return cache.get(k)!;
  }
  try {
    const { data } = await publicApiClient.get<PublicBranding>("/settings/branding", {
      params: { subdomain: k },
    });
    cache.set(k, data);
    return data;
  } catch {
    return null;
  }
}

export function clearPublicBrandingCache(subdomain: string): void {
  const key = subdomain.trim().toLowerCase();
  if (key) {
    cache.delete(key);
  }
}
